import React, { useState, useEffect } from "react";
import "./Header.css";
import Notifications from "../../Components/UiComponents/Notifications/Notifications";
import {
  centerLogoUrl,
  getUserImage,
  leftLogoUrl,
  userMgmtService,
} from "../../Services/EndPoints";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { isNotNullOrEmptyOrUndefined } from "../../Components/UiComponents/utils";
import Signout from "../../Pages/Common/Signout/Signout";

const Header = () => {
  const { profileData } = useSelector((store) => store.data);
  const [avtarImg, setAvtarImg] = useState(null);
  const centerLogo = `${centerLogoUrl}center_logo.svg`;
  const leftLogo = `${leftLogoUrl}left_logo.svg`;
  const navigate = useNavigate();

  useEffect(() => {
    let id = profileData?.photo?.id;
    if (isNotNullOrEmptyOrUndefined(id))
      setAvtarImg(userMgmtService + getUserImage + id);
  }, [profileData]);

  const getUserName = () => {
    if (
      profileData !== null &&
      profileData?.firstName &&
      profileData?.lastName
    ) {
      return `${profileData.firstName} ${
        profileData?.middleName ? profileData?.middleName : ""
      } ${profileData.lastName}`;
    } else return "Not Signed In";
  };

  return (
    <div className="header_position">
      <div className="logo_position">
        <img src={leftLogo} className="product_logo_size" />
      </div>
      <div className="logo_position">
        <img src={centerLogo} className="logo_size" />
      </div>

      <div className="header_nav-right">
        {/* <Notifications /> */}
        <div className="user-details">
          <span className="user-name">
            <div>{getUserName()}</div>
          </span>
          <span className="user-role">
            {profileData?.department || "Not Available"}
          </span>
        </div>

        <div
          className="profile cursor-pointer"
          onClick={() => {
            navigate("/userProfile");
          }}
        >
          <img src={avtarImg} className="avatar" />
        </div>
        <Signout />
      </div>
    </div>
  );
};

export default Header;
